var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440,120v-8.88c21.645-22.091,21.283-57.547-0.808-79.192C417.1,10.283,381.645,10.645,360,32.736 c-21.333,21.773-21.333,56.61,0,78.384V120h-16v16h112v-16H440z M429.817,98.591c-0.991,1.109-2.044,2.161-3.153,3.153 c-1.693,1.516-2.662,3.68-2.664,5.952V120h-16V99.312l21.656-21.656l-11.312-11.312L400,84.688l-18.344-18.344l-11.312,11.312 L392,99.312V120h-16v-12.296c0-2.275-0.969-4.443-2.664-5.96c-16.467-14.726-17.879-40.013-3.153-56.481 c14.726-16.467,40.013-17.879,56.481-3.153C443.131,56.837,444.543,82.124,429.817,98.591z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 16,
    height: 16
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 184,
    width: 16,
    height: 16
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72,32c-22.091,0-40,17.909-40,40s17.909,40,40,40s40-17.909,40-40C111.974,49.92,94.08,32.026,72,32z M72,96 c-13.255,0-24-10.745-24-24s10.745-24,24-24s24,10.745,24,24S85.255,96,72,96z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,280H304V8c0-4.418-3.582-8-8-8H8C3.582,0,0,3.582,0,8v432c0,4.418,3.582,8,8,8h32v8c0,13.255,10.745,24,24,24 s24-10.745,24-24v-8h72v24c0,4.418,3.582,8,8,8h304c4.418,0,8-3.582,8-8V288C480,283.582,476.418,280,472,280z M463.2,296 c-3.827,18.611-20.199,31.976-39.2,32H216c-19.001-0.024-35.373-13.389-39.2-32H463.2z M72,456c0,4.418-3.582,8-8,8s-8-3.582-8-8 v-24h16V456z M72,416H56v-16h16V416z M72,384H56V256h16V384z M56.944,240L64,225.888L71.056,240H56.944z M160,288v144H88V240 c0.001-1.241-0.286-2.465-0.84-3.576l-16-32c-2.358-3.954-7.475-5.249-11.429-2.891c-1.189,0.709-2.182,1.702-2.891,2.891l-16,32 c-0.554,1.111-0.841,2.335-0.84,3.576v192H16V16h272v264H168C163.582,280,160,283.582,160,288z M464,464H176V327.12 c10.509,10.794,24.935,16.882,40,16.88h208c15.065,0.002,29.491-6.086,40-16.88V464z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,152H328c-4.418,0-8,3.582-8,8v96c0,4.418,3.582,8,8,8h144c4.418,0,8-3.582,8-8v-96C480,155.582,476.418,152,472,152z  M464,248H336v-80h128V248z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 216,
    width: 40,
    height: 16
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 48,
    width: 136,
    height: 16
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 80,
    width: 104,
    height: 16
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 400,
    width: 16,
    height: 16
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 400,
    width: 104,
    height: 16
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 432,
    width: 72,
    height: 16
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 184,
    width: 56,
    height: 16
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null)), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null)), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null)), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null)), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null)), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null)), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null)), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null)), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandCampaigns);
export default __webpack_public_path__ + "static/media/brand_campaigns.9fe35603.svg";
export { ForwardRef as ReactComponent };